import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import BusinessProfileAppResource from './BusinessProfileAppResource';

class BusinessScheduleAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Business-Schedule';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'businesses/schedules';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'day',
            'dayIndex',
            'open',
            'close',
            'isClosed',
            'businessProfileUuid',
            'businessProfile',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            businessProfile: BusinessProfileAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            businessProfile: 'business_profile_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            day: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
                inclusion: [
                    'Monday',
                    'Tuesday',
                    'Wednesday',
                    'Thursday',
                    'Friday',
                    'Saturday',
                    'Sunday',
                ],
            },
            dayIndex: {
                presence: true,
                numericality: true,
            },
            open: {
                type: 'string',
            },
            close: {
                type: 'string',
            },
            isClosed: {
                type: 'boolean',
            },
            businessProfileUuid: {
                type: 'string',
                presence: true,
            },
        };
    }

}

export default BusinessScheduleAppResource;
